module.exports = __webpack_public_path__ + "static/media/dwt-02.3121c3c4.jpg";